import React, { Component } from 'react';
import Button from "../elements/Buttons";
 
class TimeoutScreen extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let LBL_Minimize, LBL_Refresh, MSG_Text, CLS_text;
        if(this.props.language && this.props.language==='ar'){
            LBL_Minimize='تصغير';
            LBL_Refresh='تحديث';
            MSG_Text='فضلاً، يرجى تحديث الصفحة للدخول إلى الخدمات';
            CLS_text='text-arabic extended';
        } else {
            LBL_Minimize='Minimize';
            LBL_Refresh='Refresh';
            MSG_Text='Please refresh the page to access the services';
            CLS_text='extended';
        }
        
        if(this.props.inputType==='timeout' && this.props.language==='ar'){
        	LBL_Minimize='تصغير';
            LBL_Refresh='خدماتنا';
            MSG_Text='لخدمتك بشكل أفضل يرجى التوجه للخدمات الرئيسية';
            CLS_text='text-arabic extended';
        	
        } 
        if (this.props.inputType==='timeout' && this.props.language==='en'){
        	LBL_Minimize='Minimize';
            LBL_Refresh='Our services';
            MSG_Text='To serve you well, please proceed to our services';
            CLS_text='extended';
        	
        }
        if(this.props.isFirstMessageScr && this.props.isFirstMessageScr===true){
            return(
<div className="user-data-modal hasIcon" style={{padding:"25px 25px 50px"}} id="firstMessageModel">
<div className="pre-chat">
<form className="text-center">
<div className="user-data-modal-text extended">
<h3 className={CLS_text}>{MSG_Text}</h3>
</div>
                            {/* <HorizontalLine className="style1"></HorizontalLine> */}
                            {/* <div className="user-data-modal-text"><span>أهلا ! أنا مساعدك الافتراضي.<br/> كيف يمكنني مساعدك؟</span></div> */}
<Button
                                id="torefresh"
                                type="button"
                                classes="user-data-modal-submit inline"
                                title={LBL_Refresh}
                                action={this.props.timeoutMessageAction}
                                areaLabel={LBL_Refresh}
                                svg="false"
>
                                {LBL_Refresh}
</Button>
</form>
</div>
<div className="user-data-modal-filler"></div>
</div>
            )
        } else {
            return(null)
        }
    }
}
TimeoutScreen.propTypes = {
    isFirstMessageScr: React.propTypes.node,
    timeoutMessageAction: React.propTypes.node,
    backtoAction: React.propTypes.node,
    minimizeAction: React.propTypes.node,
}
export default TimeoutScreen;